/**
 * Multi-field Pro のデフォルトフィールドの定義
 */
export const defaultFieldBlocks = {
    // 基本フィールド
    h1: { type: 'text', label: '見出し1', data: '' },
    h2: { type: 'text', label: '見出し2', data: '' },
    h3: { type: 'text', label: '見出し3', data: '' },
    h4: { type: 'text', label: '見出し4', data: '' },
    h5: { type: 'text', label: '見出し5', data: '' },
    h6: { type: 'text', label: '見出し6', data: '' },
    title: { type: 'text', label: 'タイトル', data: '' },
    heading: { type: 'text', label: '見出し', data: '' },
    text: { type: 'text', label: '1行テキスト', data: '', help: 'help です。', description: 'description です。' },
    email: { type: 'email', label: 'Email', data: '' },
    url: { type: 'url', label: 'URL', data: '' },
    urlText: { type: 'text', label: 'URL', data: '' },
    tel: { type: 'tel', label: '電話番号', data: '' },
    password: { type: 'password', label: 'パスワード', data: '' },
    number: { type: 'number', label: '数値', data: '' },
    date: { type: 'date', label: '日付', data: '' },
    datepicker: { type: 'datepicker', label: '日付', data: '' },
    time: { type: 'time', label: '時刻', data: '' },
    textarea: { type: 'textarea', label: '複数行テキスト', rows: 8, data: '' },
    code: { type: 'code', label: 'コードブロック', rows: 4, data: '' },
    tinymce: { type: 'tinymce', label: 'リッチテキスト', rows: 8, data: '' },
    asset: { type: 'asset', label: 'ファイル', data: { id: '', url: '' } },
    asset2: { type: 'asset', label: 'ファイル2', data: { id: '', url: '' } },
    image: {
        type: 'image',
        label: '画像',
        hasTextField: true,
        textFieldLabel: 'altテキスト',
        data: { id: '', url: '', thumbnail: '', alt: '' }
    },
    image2: {
        type: 'image',
        label: '画像2',
        hasTextField: true,
        textFieldLabel: 'altテキスト',
        data: { id: '', url: '', thumbnail: '', alt: '' }
    },
    contentData: {
        type: 'contentData',
        label: 'コンテンツデータ',
        siteId: 1,
        contentTypeId: 1,
        radio: false,
        modalEdit: true,
        modalCreate: true,
        includeDraft: false,
        status: null,
        params: null,
        dataLabelName: 'データラベル',
        selectButtonLabel: '',
        createButtonLabel: '',
        paginate: {
            limit: 20
        },
        options: [],
        data: []
    },
    select: {
        type: 'select',
        label: 'ドロップダウンリスト',
        data: '',
        options: [
            { label: 'リンゴ', data: 'apple' },
            { label: 'オレンジ', data: 'orange' },
            { label: 'キウィフルーツ', data: 'kiwi' }
        ]
    },
    selectMultiple: {
        type: 'select-multiple',
        label: '複数選択ドロップダウンリスト',
        data: [],
        options: [
            { label: 'リンゴ', data: 'apple' },
            { label: 'オレンジ', data: 'orange' },
            { label: 'キウィフルーツ', data: 'kiwi' }
        ]
    },
    checkbox: {
        type: 'checkbox',
        label: 'チェックボックス',
        data: [],
        options: [
            { label: 'リンゴ', data: 'apple' },
            { label: 'オレンジ', data: 'orange' },
            { label: 'キウィフルーツ', data: 'kiwi' }
        ]
    },
    radio: {
        type: 'radio',
        label: 'ラジオボタン',
        data: '',
        options: [
            { label: 'リンゴ', data: 'apple' },
            { label: 'オレンジ', data: 'orange' },
            { label: 'キウィフルーツ', data: 'kiwi' }
        ]
    },
    tableText: { type: 'text', label: '表内テキスト', data: '' },
    table: {
        type: 'table',
        label: '表',
        data: [],
        fields: [
            'tableText',
            'text',
            'email',
            'url',
            'tel',
            'password',
            'number',
            'datepicker',
            'time',
            'textarea',
            'code',
            'select',
            'checkbox',
            'radio',
            'tinymce',
            'asset',
            'image'
        ]
    },
    table2: {
        type: 'table',
        label: '表',
        data: [],
        fields: [
            'tableText',
            'text',
            'email',
            'url',
            'tel',
            'password',
            'number',
            'date',
            'time',
            'textarea',
            'code',
            'select',
            'checkbox',
            'radio',
            'tinymce',
            'asset',
            'image'
        ]
    },
    tableSimple: {
        type: 'table',
        label: '表',
        data: [],
        fields: ['text', 'datepicker', 'time', 'textarea', 'select', 'checkbox', 'radio', 'tinymce', 'asset', 'image']
    },
    tableVerticalFixed: {
        type: 'table-vertical-fixed',
        label: '縦向き固定テーブル',
        data: {},
        fields: [
            'tableText',
            'text',
            'email',
            'url',
            'tel',
            'password',
            'number',
            'datepicker',
            'time',
            'textarea',
            'code',
            'select',
            'checkbox',
            'radio',
            'tinymce',
            'asset',
            'asset2',
            'image',
            'image2'
        ]
    },
    chunk: {
        type: 'chunk',
        label: 'フィールドセット',
        data: {},
        fields: [
            'tableText',
            'text',
            'email',
            'url',
            'tel',
            'password',
            'number',
            'datepicker',
            'time',
            'textarea',
            'code',
            'select',
            'checkbox',
            'radio',
            'tinymce',
            'asset',
            'asset2',
            'image',
            'image2'
        ]
    },
    multiColumn: {
        type: 'multi-column',
        label: 'マルチカラム',
        data: {},
        columns: [
            {
                col: 6,
                class: '',
                label: '<div class="h4 font-weight-bold">左カラム</div>',
                description: '<p>左カラムの説明です。</p>',
                fields: ['firstName', 'lastName', 'nickname', 'image']
            },
            {
                col: 6,
                class: '',
                label: '<div class="h4 font-weight-bold">右カラム</div>',
                description: '<p>右カラムの説明です。</p>',
                fields: ['dob', 'hobby', 'asset']
            },
            { col: 12, class: '', label: '', description: '', fields: ['note01', 'note02', 'note03'] },
            { col: 12, class: '', label: '', description: '', fields: ['table2'] },
            { col: 12, class: '', label: '', description: '', fields: ['tableVerticalFixed'] }
        ]
    },
    // スライダー
    slider: {
        type: 'slider',
        label: 'スライダー',
        description: '',
        hasLoopType: true,
        innerBlocks: {
            loopType: {
                type: 'select',
                label: 'ループタイプ',
                data: '',
                options: [
                    { label: '自動スタート ＋ ループなし', data: 'auto-none' },
                    { label: '自動スタート ＋ ループあり', data: 'auto-loop' },
                    { label: '自動スタートなし ＋ ループなし', data: 'none-none' },
                    { label: '自動スタートなし ＋ ループあり', data: 'none-loop' }
                ]
            },
            image: {
                type: 'image',
                label: '画像',
                hasTextField: true,
                textFieldLabel: 'altテキスト',
                data: { id: '', url: '', thumbnail: '', alt: '' }
            },
            title: { type: 'text', label: '見出し', data: '' },
            lead: { type: 'text', label: 'リード', data: '' },
            url: { type: 'text', label: 'URL', data: '' }
        },
        data: { content: [] }
    },
    // カード
    contentCard: {
        type: 'contentCard',
        label: 'コンテンツ',
        description: '',
        innerBlocks: {
            image: {
                type: 'image',
                label: '画像',
                hasTextField: true,
                textFieldLabel: 'altテキスト',
                data: { id: '', url: '', thumbnail: '', alt: '' }
            },
            title: { type: 'text', label: '見出し', data: '' },
            lead: { type: 'tinymce', label: 'リード', data: '' },
            url: { type: 'text', label: 'URL', data: '' },
            category: {
                type: 'checkbox',
                label: 'カテゴリ',
                data: [],
                options: [
                    { label: 'リンゴ', data: 'apple' },
                    { label: 'オレンジ', data: 'orange' },
                    { label: 'キウィフルーツ', data: 'kiwi' }
                ]
            }
        },
        data: { content: [] }
    },
    // 汎用フィールド
    multipurpose: {
        type: 'multipurpose',
        label: '汎用フィールド',
        description: '自由な組み合わせが可能で汎用的に利用できるフィールドです。',
        addClass: [''],
        innerGroups: [
            {
                handle: 'group01',
                title: 'グループタイトル01',
                description: 'グループの概要01 | fixed: true, hasBorder: true',
                hasBorder: true,
                fixed: true,
                addGroupClass: '',
                fields: ['title', 'image', 'asset', 'lead']
            },
            {
                handle: 'group02',
                title: 'グループタイトル02',
                description: 'グループの概要02 | fixed: true, hasBorder: false',
                hasBorder: false,
                fixed: true,
                addGroupClass: '',
                fields: ['url', 'category']
            },
            {
                handle: 'group03',
                title: 'グループタイトル03',
                description: 'グループの概要03 | fixed: false, hasBorder: false',
                hasBorder: false,
                fixed: false,
                addGroupClass: '',
                fields: ['title', 'image', 'asset', 'lead']
            },
            {
                handle: 'group04',
                title: 'グループタイトル04',
                description: '',
                hasBorder: false,
                fixed: false,
                addGroupClass: '',
                fields: ['table', 'tableVerticalFixed', 'contentData', 'chunk']
            }
        ],
        innerBlocks: {
            title: { type: 'text', label: '見出し', data: '' },
            image: {
                type: 'image',
                label: '画像',
                hasTextField: true,
                textFieldLabel: 'altテキスト',
                data: { id: '', url: '', thumbnail: '', alt: '' }
            },
            lead: { type: 'tinymce', label: 'リード', data: '' },
            url: { type: 'text', label: 'URL', data: '' },
            category: {
                type: 'checkbox',
                label: 'カテゴリ',
                data: [],
                options: [
                    { label: 'リンゴ', data: 'apple' },
                    { label: 'オレンジ', data: 'orange' },
                    { label: 'キウィフルーツ', data: 'kiwi' }
                ]
            }
        },
        data: {}
    },
    // サンプル
    nickname: { type: 'text', label: 'ニックネーム', data: '' },
    lastName: { type: 'text', label: '姓', data: '' },
    firstName: { type: 'text', label: '名', data: '' },
    dob: { type: 'datepicker', label: '誕生日', data: '' },
    hobby: { type: 'textarea', label: '趣味', data: '' },
    note01: { type: 'tinymce', label: '備考', data: '' },
    note02: { type: 'tinymce', label: '注意事項', data: '' },
    note03: { type: 'tinymce', label: 'メッセージ', data: '' },
    sample01: { type: 'text', label: 'リンクテキスト', data: '' },
    sample02: { type: 'url', label: 'URL', class: 'col-4', data: '' },
    sample03: { type: 'checkbox', label: 'リンクタイプ', data: '', options: [{ label: '別ウィンドウ', data: '_blank' }] }
};
